<template>
    <div>
        <page-header :title="title" :items="items" />

        <awesome-table
            :labels="labels"
            :items="filtered"
            :options="options"
            :pagination="pagination"
            @row-click="goToEdit"
            @search="onSearch"
            @pagination-change="onPaginationChange"
        />
    </div>
</template>

<script>
import _ from 'lodash';
import { mapActions } from 'vuex';

export default {
    page: {
        title: 'Contents'
    },

    data() {
        return {
            title: 'Contents',
            items: [
                {
                    text: 'Aguda',
                    to: '/'
                },
                {
                    text: 'Contents',
                    active: true
                }
            ],
            labels: ['name', 'type'],
            filtered: [],
            contents: [],
            options: {
                addButton: false,
                pagination: false,
                sort: true,
                link: false,
                filters: false,
                selectField: 'key'
            },
            pagination: {}
        };
    },

    async created() {
        try {
            this.contents = await this.getContents();

            this.filtered = [...this.contents];
        } catch (error) {
            console.error(error);

            this.$toasterError();
        }
    },

    methods: {
        ...mapActions({
            getContents: 'contents/index'
        }),

        goToEdit(item) {
            this.$router.push(`/contents/${_.kebabCase(item.key)}`);
        },

        onSearch(search) {
            if (!search) {
                this.filtered = [...this.contents];
            }

            this.filtered = this.contents.filter(i =>
                i.name.toLowerCase().includes(search.toLowerCase())
            );

            this.sort();
        },

        onPaginationChange(pagination) {
            this.pagination = { ...pagination };

            this.sort();
        },

        sort() {
            this.filtered.sort((a, b) => {
                if (this.pagination.descending) {
                    if (a[this.pagination.sortBy] < b[this.pagination.sortBy]) {
                        return -1;
                    }

                    return 1;
                }

                if (b[this.pagination.sortBy] < a[this.pagination.sortBy]) {
                    return -1;
                }

                return 1;
            });
        }
    }
};
</script>
